import { useEffect, useState } from 'react'

// https://stackoverflow.com/questions/63406435/how-to-detect-window-size-in-next-js-ssr-using-react-hook
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match.
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  })

  function handleResize() {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }

  useEffect(function setupListeners() {
    // Prevent adding unlimited event listeners (due to hot reload in dev mode).
    window.removeEventListener('resize', handleResize, { capture: true })
    window.addEventListener('resize', handleResize, { capture: true })
    // Call handler right away so state gets updated with initial window size.
    handleResize()
    return function cleanupListeners() {
      window.removeEventListener('resize', handleResize, { capture: true })
    }
  }, [])
  return windowSize
}

export default useWindowSize
